export function SwotFieldError(props: { readonly messages?: readonly string[] | undefined; readonly fieldName?: string | undefined }) {
  const messages = (props.messages ?? []).filter((item) => item.trim().length > 0);
  if (messages.length === 0) return null;
  const id = props.fieldName ? `${props.fieldName}-errors` : undefined;
  return (
    <ul id={id} className="swot-field-error" role="alert" aria-live="polite">
      {messages.map((message, index) => <li key={`${message}-${index}`}>{message}</li>)}
    </ul>
  );
}
